 export function callVariant(dateField:any):any{

return {viewName: "Calendar",
          viewVariation: `Calendar-${dateField.name}`,
          byField: dateField.name,
          calendar:[dateField.name, dateField.name]}

}
